"use strict";

var _toConsumableArray = function (arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i]; return arr2; } else { return Array.from(arr); } };

var _slice = Array.prototype.slice;
var angular = require("angular-fix");

module.exports = function (ngModule) {
  ngModule.directive("formlyForm", formlyForm);

  formlyForm.tests = ON_TEST ? require("./formly-form.test")(ngModule) : null;

  function formlyForm(formlyUsability) {
    var currentFormId = 1;
    return {
      restrict: "E",
      template: function template(el, attrs) {
        /* jshint -W033 */ // this because jshint is broken I guess...
        var rootEl = attrs.rootEl || "ng-form";
        return "\n          <" + rootEl + " class=\"formly\"\n                   name=\"form\"\n                   role=\"form\">\n            <div formly-field\n                 ng-repeat=\"field in fields track by $index\"\n                 ng-if=\"!field.hide\"\n                 class=\"formly-field {{field.type ? 'formly-field-' + field.type : ''}}\"\n                 options=\"field\"\n                 model=\"field.model || model\"\n                 fields=\"fields\"\n                 form=\"form\"\n                 form-id=\"formId\"\n                 form-state=\"options.formState\"\n                 index=\"$index\">\n            </div>\n            <div ng-transclude></div>\n          </" + rootEl + ">\n        ";
      },
      replace: true,
      transclude: true,
      scope: {
        fields: "=",
        model: "=", // we'll do our own warning to help with migrations
        form: "=?",
        options: "=?"
      },
      controller: ["$scope", function controller($scope) {
        $scope.formId = "formly_" + currentFormId++;
        $scope.options = $scope.options || {};
        $scope.options.formState = $scope.options.formState || {};

        angular.forEach($scope.fields, attachKey); // attaches a key based on the index if a key isn't specified
        angular.forEach($scope.fields, setupWatchers); // setup watchers for all fields

        // watch the model and evaluate watch expressions that depend on it.
        $scope.$watch("model", function onResultUpdate(newResult) {
          angular.forEach($scope.fields, function (field) {
            /*jshint -W030 */
            field.runExpressions && field.runExpressions(newResult);
          });
        }, true);

        function attachKey(field, index) {
          field.key = field.key || index || 0;
        }

        function setupWatchers(field, index) {
          if (!angular.isDefined(field.watcher)) {
            return;
          }
          var watchers = field.watcher;
          if (!angular.isArray(watchers)) {
            watchers = [watchers];
          }
          angular.forEach(watchers, function (watcher) {
            if (!angular.isDefined(watcher.listener)) {
              throw formlyUsability.getFieldError("all-field-watchers-must-have-a-listener", "All field watchers must have a listener", field);
            }
            var watchExpression = getWatchExpression(watcher, field, index);
            var watchListener = getWatchListener(watcher, field, index);

            var type = watcher.type || "$watch";
            watcher.stopWatching = $scope[type](watchExpression, watchListener, watcher.watchDeep);
          });
        }

        function getWatchExpression(watcher, field, index) {
          var watchExpression = watcher.expression || "model['" + field.key + "']";
          if (angular.isFunction(watchExpression)) {
            // wrap the field's watch expression so we can call it with the field as the first arg
            // and the stop function as the last arg as a helper
            var originalExpression = watchExpression;
            watchExpression = function formlyWatchExpression() {
              var args = modifyArgs.apply(undefined, [watcher, index].concat(_slice.call(arguments)));
              return originalExpression.apply(undefined, _toConsumableArray(args));
            };
            watchExpression.displayName = "Formly Watch Expression for field for " + field.key;
          }
          return watchExpression;
        }

        function getWatchListener(watcher, field, index) {
          var watchListener = watcher.listener;
          if (angular.isFunction(watchListener)) {
            // wrap the field's watch listener so we can call it with the field as the first arg
            // and the stop function as the last arg as a helper
            var originalListener = watchListener;
            watchListener = function formlyWatchListener() {
              var args = modifyArgs.apply(undefined, [watcher, index].concat(_slice.call(arguments)));
              return originalListener.apply(undefined, _toConsumableArray(args));
            };
            watchListener.displayName = "Formly Watch Listener for field for " + field.key;
          }
          return watchListener;
        }

        function modifyArgs(watcher, index) {
          for (var _len = arguments.length, originalArgs = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
            originalArgs[_key - 2] = arguments[_key];
          }

          return [$scope.fields[index]].concat(originalArgs, [watcher.stopWatching]);
        }
      }],
      link: function link(scope, el, attrs) {
        if (attrs.hasOwnProperty("result")) {
          throw formlyUsability.getFormlyError("The \"result\" attribute on a formly-form is no longer valid. Use \"model\" instead");
        }
        if (attrs.name !== "form") {
          // then they specified their own name
          throw formlyUsability.getFormlyError("The \"name\" attribute on a formly-form is no longer valid. Use \"form\" instead");
        }
      }
    };
  }
  formlyForm.$inject = ["formlyUsability"];
};


/*****************
 ** WEBPACK FOOTER
 ** ./directives/formly-form.js
 ** module id = 6
 ** module chunks = 0
 **/